import { useCallback } from 'react'
import ModalDeleteFilled from '../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import twinFetchPost from '../../../../../../../utils/globals/data'
import { changeErrorMessage } from '../../../../../../../utils/reducers/reduxDispatch'
import { OnSubmit } from '../../../../../../../forms/TwinForm/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import useIsLoading from '../../../../../../../utils/hooks/useIsLoading'

interface ModalDeleteEmployeeProps extends ModalEditComponentProps { }

const ModalDeleteEmployee: React.FC<ModalDeleteEmployeeProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleSubmit, loading } = useModalDeleteEmployeeLogic({allRowData, onSubmit})
    let translations = {
        title: t('sureUnableEmployee', '¿Seguro quieres desactivar este empleado?'),
        subtitle: t('onceDeletedCouldBeRecovered', 'Una vez desactivado se podrá reactivar de nuevo'),
        buttonAccept: t('unable', 'Desactivar')
    }
    if (!allRowData?.active) {
        translations = {
            title: t('sureEnableEmployee', '¿Seguro quieres activar este empleado?'),
            subtitle: t('onceEnabledCouldBeDeletedF', 'Una vez activada se podrá desactivar de nuevo'),
            buttonAccept: t('enable', 'Activar')
        }
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleSubmit} translations={translations} loading={loading} />
    )
}

interface ModalDeleteEmployeLogicProps {
    allRowData?: RowData
    onSubmit: OnSubmit
}

const useModalDeleteEmployeeLogic = ({ onSubmit, allRowData }: ModalDeleteEmployeLogicProps) => {
    const {t} = useTwinTranslation()
    const { startLoading, endLoading, loading } = useIsLoading()

    const errorMsg = t('cantUnactiveEmployeeWithUserAssigned','No puedes desactivar un empleado con usuario asignado ')
    const handleSubmit = useCallback(async () => {
        startLoading()
        const response = await twinFetchPost('/api/app/employee/updateEmployeeForActive', {
            id: allRowData?.id,
            active: !allRowData?.active
        })
        if (response.status === 200) {
            onSubmit?.(response, {
                id: allRowData?.id,
                active: !allRowData?.active
            })
        } else {
            const responseJSON = await response.json()
            if (responseJSON.errors[0].msg === 'You can not delete a Employee with a user assigned.') {
                changeErrorMessage(errorMsg)
            }
        }
        endLoading()
    }, [allRowData?.id, allRowData?.active, errorMsg, onSubmit, startLoading, endLoading])
    return { handleSubmit, loading }
}


export default ModalDeleteEmployee